const START_PAGE = '/';
// The map page: default post-login landing + offline-recovery redirect target.
const MAIN_MAP = '/main_map';
// TMDXNC-425 — the New Cases Map: the same map engine and controls as
// `/main_map`, drawing new cases only.
const NEW_CASES_MAP = '/new_cases_map';
const ERRORS = '/errors';
const STATISTICS = '/statistics';
const HUBS_REPORT = '/hubs_report';
const SETTINGS = '/settings';
const MY_SETTINGS = '/me/settings';
// TMDXNC-241 — the admin panel (v1: user list with live online status).
const ADMIN = '/admin';
const STATS = '/stats/*';
const STATS_FR = '/stats/fr';
const STATS_FH = '/stats/fh';
const STATS_UPTIME = '/stats/uptime';
const STATS_DOWNTIME = '/stats/downtime';
const STATS_MTTR = '/stats/mttr';
const STATS_MTBA = '/stats/mtba';
const STATS_AOGDR = '/stats/aogdr';

// `CASE_TIMELINE` serves the Cases Timeline List; `ALERTS_DASHBOARD` is ported from cc3-event-poc.
const CASE_TIMELINE = '/case-timeline';
const ALERTS_DASHBOARD = '/alerts-dashboard';

const AVIATION_TIMELINE = '/aviation-timeline';

// TMDXNC-68 — the per-hub Hub Dashboard. The hub is a route *parameter*, not a
// screen variant: the 30 location aliases in `hubNameMapping` collapse to 20
// display hubs, so one component is driven by the `hub.id` the hubs resource
// report sends. The hub picker behind the header chevron is undesigned, so the
// hubs report is the entry point for now.
const HUB_DASHBOARD = '/hub-dashboard/:hubId';

const PAGE_NOT_FOUND = '/404';
const NO_ACCESS = '/403';
const LOGOUT = '/logout';

export const routes = {
  START_PAGE,
  MAIN_MAP,
  NEW_CASES_MAP,
  ERRORS,
  STATISTICS,
  PAGE_NOT_FOUND,
  LOGOUT,
  HUBS_REPORT,
  SETTINGS,
  MY_SETTINGS,
  ADMIN,
  STATS,
  STATS_FR,
  STATS_FH,
  STATS_UPTIME,
  STATS_DOWNTIME,
  STATS_MTTR,
  STATS_MTBA,
  STATS_AOGDR,
  NO_ACCESS,
  CASE_TIMELINE,
  ALERTS_DASHBOARD,
  AVIATION_TIMELINE,
  HUB_DASHBOARD,
};

/** `HUB_DASHBOARD` with its parameter filled in — the link to one hub's dashboard. */
export const hubDashboardPath = (hubId: string): string =>
  HUB_DASHBOARD.replace(':hubId', encodeURIComponent(hubId));
